import _initializerDefineProperty from "@babel/runtime/helpers/initializerDefineProperty";
import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _createClass from "@babel/runtime/helpers/createClass";
import _possibleConstructorReturn from "@babel/runtime/helpers/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/getPrototypeOf";
import _inherits from "@babel/runtime/helpers/inherits";
import _applyDecoratedDescriptor from "@babel/runtime/helpers/applyDecoratedDescriptor";
import _initializerWarningHelper from "@babel/runtime/helpers/initializerWarningHelper";
var _class, _descriptor, _descriptor2, _descriptor3, _descriptor4, _descriptor5, _descriptor6, _descriptor7, _descriptor8;
function _callSuper(t, o, e) { return o = _getPrototypeOf(o), _possibleConstructorReturn(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], _getPrototypeOf(t).constructor) : o.apply(t, e)); }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
import { Model } from 'libx';
import { observable, computed } from 'mobx';
import moment from 'moment';
import uniqueId from 'lodash/uniqueId';
import { omitUndefined } from 'utils/objectUtil';
var Amendment = (_class = /*#__PURE__*/function (_Model) {
  function Amendment(attrs, opts) {
    var _this;
    _classCallCheck(this, Amendment);
    _this = _callSuper(this, Amendment, arguments);
    _this.cid = uniqueId('amendment-');
    _initializerDefineProperty(_this, "id", _descriptor, _this);
    _initializerDefineProperty(_this, "dateCreated", _descriptor2, _this);
    _initializerDefineProperty(_this, "visibility", _descriptor3, _this);
    _initializerDefineProperty(_this, "description", _descriptor4, _this);
    _initializerDefineProperty(_this, "internalNote", _descriptor5, _this);
    _initializerDefineProperty(_this, "creator", _descriptor6, _this);
    _initializerDefineProperty(_this, "customerAmount", _descriptor7, _this);
    _initializerDefineProperty(_this, "providerAmount", _descriptor8, _this);
    _this.job = opts.job;
    return _this;
  }
  _inherits(Amendment, _Model);
  return _createClass(Amendment, [{
    key: "parse",
    value: function parse(json) {
      return omitUndefined({
        id: json.date_created,
        dateCreated: moment(json.date_created),
        visibility: json.visibility,
        description: json.description,
        internalNote: json.internal_note,
        creator: this.rootStore.memberStore.setAndFetch({
          workspace_id: json.workspace_id,
          user_id: json.creator.user_id,
          user_public_id: json.creator.user_public_id
        }),
        customerAmount: json.customer_amount,
        providerAmount: json.provider_amount
      });
    }
  }, {
    key: "finalAmount",
    get: function get() {
      return this.job.providerCut * this.customerAmount + this.providerAmount;
    }
  }]);
}(Model), _descriptor = _applyDecoratedDescriptor(_class.prototype, "id", [observable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor2 = _applyDecoratedDescriptor(_class.prototype, "dateCreated", [observable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor3 = _applyDecoratedDescriptor(_class.prototype, "visibility", [observable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function initializer() {
    return 'INTERNAL';
  }
}), _descriptor4 = _applyDecoratedDescriptor(_class.prototype, "description", [observable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function initializer() {
    return '';
  }
}), _descriptor5 = _applyDecoratedDescriptor(_class.prototype, "internalNote", [observable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function initializer() {
    return '';
  }
}), _descriptor6 = _applyDecoratedDescriptor(_class.prototype, "creator", [observable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor7 = _applyDecoratedDescriptor(_class.prototype, "customerAmount", [observable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor8 = _applyDecoratedDescriptor(_class.prototype, "providerAmount", [observable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _applyDecoratedDescriptor(_class.prototype, "finalAmount", [computed], Object.getOwnPropertyDescriptor(_class.prototype, "finalAmount"), _class.prototype), _class);
export { Amendment as default };
//# sourceMappingURL=Amendment.js.map
